export const VERSION_NUMBER = '1.203';
export const BUILD_TIME = '';
export const BUILD_NOTES =
    '<ul><li>Fixed issue where a new visit that was cancelled would not show the "Submit" button if the school or the visit date was changed after the cancelled option was selected.</li></ul>';
